import script from "./ToTopButton.vue?vue&type=script&setup=true&lang=js"
export * from "./ToTopButton.vue?vue&type=script&setup=true&lang=js"

import "./ToTopButton.vue?vue&type=style&index=0&id=708ea46c&lang=scss"

const __exports__ = script;

export default __exports__